import { render, staticRenderFns } from "./LedgersSearch.vue?vue&type=template&id=589ed595"
import script from "./LedgersSearch.vue?vue&type=script&lang=js"
export * from "./LedgersSearch.vue?vue&type=script&lang=js"
import style0 from "./LedgersSearch.vue?vue&type=style&index=0&id=589ed595&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports